var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-page_about t-work-area"},[_c('h1',[_vm._v(_vm._s(_vm.pageText.title))]),_vm._v(" "),_c('div',{staticClass:"t-work-area__row"},[_c('div',{staticClass:"t-work-area__column_big"},[_c('div',{staticClass:"t-work-area__cell t-default",domProps:{"innerHTML":_vm._s(_vm.about)}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d96eb93","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue_pages/About/Index.vue
// module id = 385
// module chunks = 0